import React from 'react';
import { Link } from 'react-router-dom';
import FractalGraphLogo from '../components/ui/FractalGraphLogo';
// import './FractalGraphPage.css'; // Optional: for page-specific styles

const FractalGraphPage: React.FC = () => {
  return (
    <div className="fractal-graph-page" style={{ 
      width: '100%', 
      height: '100vh', 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      backgroundColor: '#000',
      overflow: 'hidden', // Prevent scrollbars
      position: 'relative' // Ensure proper positioning context
    }}>
      {/* Navigation back to home */}
      <Link 
        to="/"
        style={{
          position: 'fixed',
          top: '20px',
          left: '20px',
          color: 'white',
          backgroundColor: 'rgba(0,0,0,0.5)',
          padding: '10px 15px',
          borderRadius: '5px',
          textDecoration: 'none',
          zIndex: 100,
        }}
      >
        ← Back to Home
      </Link>
      
      {/* Instruction overlay */}
      <div style={{
        position: 'fixed',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        color: 'white',
        backgroundColor: 'rgba(0,0,0,0.5)',
        padding: '10px 15px',
        borderRadius: '5px',
        textAlign: 'center',
        zIndex: 100,
      }}>
        Use mouse wheel to zoom in/out and explore the fractal graph
      </div>
      
      {/* Full-size container div for the FractalGraphLogo */}
      <div style={{
        position: 'absolute',
        width: '100%', 
        height: '100%', 
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
      }}>
        <FractalGraphLogo />
      </div>
    </div>
  );
};

export default FractalGraphPage; 